<template>

  <div id="menu-upload">
        
    <h1>{{ $t("mobilityOnDemand.title") }}</h1>
    <br>
     <div class="row">
       <div class="col-lg-1 col-xl-3">
          
        </div>
        <div class="col-lg-2 col-xl-2">
          {{ $t("mobilityOnDemand.dates") }}
        </div>
        <div class="col-lg-3 col-xl-2">
            <div class="dateInput">
              <label class="black">{{ $t("mobilityOnDemand.from") }}</label>
              <br>
                <date-picker class="dateInput" v-model="dates.from" placeholder="YYYY/MM/DD" value-type="format" format="YYYY/MM/DD"></date-picker> 
               <!-- <date-picker class="dateInput" v-model="dates.from" placeholder="DD/MM/YYYY" value-type="format" format="DD/MM/YYYY"></date-picker> -->
            </div>
        </div>
        <div class="col-lg-3 col-xl-2">
         <div class="dateInput">
              <label class="black">{{ $t("mobilityOnDemand.to") }}</label>
              <br>
               <date-picker class="dateInput" v-model="dates.to" placeholder="YYYY/MM/DD" value-type="format" format="YYYY/MM/DD"></date-picker>
               <!-- <date-picker class="dateInput" v-model="dates.to" placeholder="DD/MM/YYYY" value-type="format" format="DD/MM/YYYY"></date-picker> -->
            </div>
        </div>
        <div class="col-lg-3 col-xl-3">
          <button type="button" class="publish-btn" @click="downloadReport">
          {{ $t("mobilityOnDemand.dowloadReport") }}
        </button>
        </div>
      </div>
   <br/>
            <div class="row">
                    <div class="col-lg-6 col-xl-6">
                    <h3 class="labelBold">
                          {{ this.$t(`mobilityOnDemand.ridesMobility.subtitle`) }}
                    </h3>
                    </div>
                      <div class="col-lg-3 col-xl-3">
                      </div>
                    <div class="col-lg-3 col-xl-3"> 
                    <button class="publish-btn"  @click="updateTable">
                    {{ $t("mobilityOnDemand.update") }}
                    </button>         
                    </div>
            </div>
    <div class="row">
      <div class="col-md-12">
        <v-server-table
          :columns="table_options.columns"
          :options="table_options.options"
          ref="ridesTable">
          <template #requested_date="props">{{props.row.requested_date | formatDateOnly(appLang)}}</template>
           <template #accepted_date="props">{{props.row.accepted_date | formatDateOnly(appLang)}}</template>
            <template #started_date="props">{{props.row.started_date | formatDateOnly(appLang)}}</template>
             <template #finished_date="props">{{props.row.finished_date | formatDateOnly(appLang)}}</template>
              <template #cancelled_date="props">{{props.row.cancelled_date | formatDateOnly(appLang)}}</template>
               <template #declined_date="props">{{props.row.declined_date | formatDateOnly(appLang)}}</template>

                <template #trip_status="props">{{ translateStatus(props.row.trip_status) }}</template>
          <!-- <template v-slot:actions="props"> -->
            <template #actions="props">
            <div class="actionsDrivers">
              <!-- Edit -->
              <router-link
                class="edit-btn"
                :to="{
                  name: 'Edit Driver',
                  params: {
                    id: props.row.id,
                    controlNumber: props.row.name,
                    edit: true
                    // edit: props.row
                  }
                }"
              >
                <i class="far fa-edit"></i>
              </router-link>
              <router-link
                class="edit-btn"
                :to="{
                  name: 'Driver Details',
                  params: {
                    id: props.row.id,
                    controlNumber: props.row.name,
                    data: props.row,
                    details: true
                  }
                }"
              >
                <i class="far fa-eye"></i>
              </router-link>
            </div>
          </template>
             <div slot="filter__trip_status">
              <select class="form-control" id ="trip_status"  name="trip_status" v-model="selected"  @change="filterStatus(selected)">
              <option v-for="option in options"
              v-bind:key="option.id"
              v-bind:value="option.id">
              {{option.name }}
              </option>
            </select>
            </div>
        </v-server-table>
     

      </div>
    </div>
  </div>
</template>



<script>

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import Mobility from "@/lib/api/MobilityOnDemand.js";
import store from '@/vuex/store';

const api = new Mobility();


export default {
  components: {
    DatePicker, 
    store
  },

  
    filters: {
    formatDateOnly: function(value, lang) {
      if (!value) return '';
      if (lang === 'es') {
        moment.locale("es-do");
      } else {
        moment.locale("en");
      }

      return moment(value).format("LLL");
    }
  },

  data: function() {
    return {
    selected:"",
    fechas:"",
     dates: 
    {
      from: null,
      to: null,
    },
      places: null,
      isLoading: false,
      file: null,
      fileUrl: null,
      uploadStatus: '',
      signedURL: null,
      checked:false,
      from: null,
      to: null,
    };
  },
  computed: {

      options(){
        return[
      {id:"0",name: this.$t('mobilityOnDemand.choose')} ,
      {id:1,name: this.$t('mobilityOnDemand.ridesMobility.cancelled')} ,
      {id:2,name: this.$t('mobilityOnDemand.ridesMobility.onTheWay')},
      {id:3,name: this.$t('mobilityOnDemand.ridesMobility.tripFinished')},
      {id:4,name: this.$t('mobilityOnDemand.ridesMobility.searching')} ,
      {id:5,name: this.$t('mobilityOnDemand.ridesMobility.driverArrived')},
      {id:6,name: this.$t('mobilityOnDemand.ridesMobility.tripStarted')}

        ]},

    appLang: function() {
      return this.$store.getters['settings/currentLang'];
    },
  
    ridesTable: function() {
      return this.$refs.ridesTable;
    },

    table_columns: function() {
      return [

            "driver_full_name",
            "requested_date",
            "accepted_date",
            "started_date",
            "finished_date",
            "cancelled_date",
            "declined_date",
            "trip_status",
            "starting_point",
            "arriving_point",
            "cancelled_by",
            "cancellation_reason"
 
      ];
    },

   table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `mobilityOnDemand.ridesMobility.tableTripsDetail.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },

     table_filters: function() {
      return this.table_columns.filter(column =>   column !== "requested_date" && column !== "accepted_date" && column !== "started_date" && column !== "finished_date" && column !== "cancelled_date" && column !== "declined_date"  );
   
    },

     table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPageValues: [25, 50, 100],
          perPage: 25,
          texts: {
            filterBy: "{column}",
            columns: this.$t("mobilityOnDemand.ridesMobility.tableTripsDetail.headings.column_toggler")
          },

          requestAdapter: function(data) {
            
            const queries = {};
            queries.page = data.page ;
            queries.limit = data.limit;
            const fecha = moment(new Date()).format("YYYY-MM-DD")
            
             var jsonRequest = {"requested_date":fecha};
             let xquery = Object.assign(jsonRequest, data.query)
             queries.query =  xquery ; 
            //queries.query =  data.query ; 
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            
            try {
             
              const resp = await api.getTrips(data);
              this.$store.commit("global/SET_LOADING", false);
        
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
           
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data:  response.data,
              count: response.total
            };
          }
        }
      };
    }
  },

  beforeMount: async function() {
  },
  created: async function() {
  },
  methods: {

    updateTable: function () {
    this.ridesTable.refresh();
    },

    filterStatus: function($event)
    {
      let status = ""
      if ($event == 1){
    	status = "cancelled"
	    }
      else if($event == 2){
    	status = "onTheWay"
	    }
      else if($event == 3){
    	status = "tripFinished"
	    }
      else if($event == 4){
    	status = "searching"
	    }
      else if($event == 5){
    	status = "driverArrived"
	    }
      else if($event == 6){
    	status = "tripStarted"
	    }
    this.ridesTable.setFilter({"trip_status":status});
    },

    translateStatus (status) {

      if (status == "cancelled"){
      status = this.$t("mobilityOnDemand.ridesMobility.cancelled")
      }
      else if(status == "onTheWay"){
       status = this.$t("mobilityOnDemand.ridesMobility.onTheWay")
      }
       else if(status == "tripFinished"){
       status =  this.$t("mobilityOnDemand.ridesMobility.tripFinished")
       }
       else if(status == "searching"){
        status = this.$t("mobilityOnDemand.ridesMobility.searching")
        }
        else if(status == "driverArrived"){
        status = this.$t("mobilityOnDemand.ridesMobility.driverArrived")
      }
        else if(status == "tripStarted"){
        status = this.$t("mobilityOnDemand.ridesMobility.driverArrived")
       
      }
       else {
        status
      }
        return status
    },

     
 
 downloadReport: async function(event) {
      this.$store.commit("global/SET_LOADING", true);
      try {

        if(this.dates.to < this.dates.from || this.dates.to == null|| this.dates.from == null)
        {
           if(this.dates.to < this.dates.from )
           {
       
               this.$store.commit("global/SET_LOADING", false);
               this.$store.commit("global/SET_ALERT", {
                msg: `${this.$t("mobilityOnDemand.rango")}`,
                show: true,
                type: "error"
               });
           }  
            else{
                  this.$store.commit("global/SET_LOADING", false);
                      this.$store.commit("global/SET_ALERT", {
                  msg: `${this.$t("mobilityOnDemand.vacias")}`,
                  show: true,
                  type: "error"});
                }
        }
          else
                { 
                const getDate = (type = "from") => {
                const time = type === "from" ? "00:00" : "23:59";
                return `${this.dates[type]}`;
                };
                const params = {
                   startDate: getDate("from").split('/').reverse().join('/'),
                   endDate: getDate("to").split('/').reverse().join('/')
                
                 
                };
                const resp = await api.downloadTripsReport(params);
                let anchor = document.createElement("a");
                anchor.href = resp.url;
                anchor.target = "_blank";
                anchor.click();
                  this.$store.commit("global/SET_LOADING", false);
                  this.$store.commit("global/SET_ALERT", {
                  msg: `${this.$t("mobilityOnDemand.dowloadSuccess")}`,
                  show: true,
                  type: "success"
                });
                }

      } catch (error) {
        console.log(error);
                  this.$store.commit("global/SET_LOADING", false);
                  this.$store.commit("global/SET_ALERT", {
                  msg: error,
                  show: true,
                  type: "error"
                });
    
      }
      
    }
  
  }
};
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
</style>


<style lang="scss">

@media (min-width: 576px) {
  .dateInput{
  width: auto;
  height: 30px;
}
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) { 
  .dateInput{
  width: auto;
  height: 30px;
}}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .dateInput{
  width: auto;
  height: 30px;
}}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) { 
  .dateInput{
  width: auto;
  height: 30px;
  
}
}

#menu-upload {
  background-color: $white;
  padding: 2rem 4rem;
}



.publish-btn {

  margin-left: 1rem;
  padding:1rem 1rem;
  background: #000;
  color: #fff;
  border: 1px solid #000;
  border-radius: 0px;
  
}

    .VueTables thead  { 
            position: sticky;
            top: 0;
            z-index: 10;
            background-color: #ffffff;
            border: 1px solid #000;
        }
    
        .table-responsive { 
            height:600px;
            overflow:scroll;
        }

  .VueTables__trip_status-filter-wrapper {
  visibility:hidden;
  position: relative;
  z-index: 5;
 }
#trip_status{
  position: absolute;
  top: 10%;
  z-index: 10;
  width:auto;
  visibility:visible;
}

.VueTables .dropdown {
  margin: 1rem 0;
}
.VueTables__columns-dropdown {
  float: left !important;
}
.VueTables__columns-dropdown > button {
  color: #000 !important;
  background-color: transparent !important;
  border: 1px solid #000 !important;
  border-radius: 0 !important;
  padding: 5px 10px !important;
}
.VueTables .dropdown .dropdown-menu {
  padding: 1rem;
}
.VueTables .dropdown .dropdown-menu a {
  color: #000;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.VueTables .dropdown .dropdown-menu a > input {
  margin-right: 0.5rem;
}



</style>
<style lang="scss" >





.actionsDrivers {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.actionsDrivers > *, button {
  cursor: pointer;
}
.actionsDrivers > .edit-btn {
  color: #000000;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  &:hover {
    color: #000000;
  }
}

</style>
